import { useAuthContext, useGlobalFilterContext, usePageContentContext } from '@synergy/microfrontend_core';
import { styled } from "styled-components";
import query from "../../server/constants.api";
import logger from "../../server/server";
import { REACT_APP_PROJECT_NAME } from "../../utils/config/configs";
import { Filters } from "../App/Filter/Filters";
import { Footer } from "../App/Footer";
import { Header } from "../App/Header";

import { Suspense, lazy, useEffect, useMemo, useState } from "react";

const ALL_MUNICIPALITIES_VALUE = "__all_municipalities__";

// Lazy load the micro frontends
const Map = lazy(() => import('@synergy/microfrontend_map'));
const Registry = lazy(() => import('@synergy/microfrontend_registry'));
const Events = lazy(() => import('@synergy/microfrontend_events'));
const Configurations = lazy(() => import('@synergy/microfrontend_configurations'));
const Analytics = lazy(() => import('@synergy/microfrontend_analytics'));
const Homepage = lazy(() => import('@synergy/microfrontend_homepage'));
const Buildings = lazy(() => import('@synergy/microfrontend_buildings'));

//#region  Styled Components
//Where we define the styles, CSS and other aspects for the page components
const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: clip;
`;

const MainContent = styled.div`
    display: flex;
    height: calc(100% - 88px);
    /* overflow: hidden; */
    /* flex-direction: column; */
    /* min-height: 100vh - 93px; */
`;

const RightContent = styled.div`
    display: flex;
    flex-direction: column;
    /* justify-content: space-between; */
    width: 100%;
    overflow-y: auto;
    justify-content: space-between;
`;

const FiltersContainer = styled.div`
    display: block;
    z-index: 1;
`;
//#endregion
export function Home() {
  const { user, tenant, tags, zones, permissions, token } = useAuthContext();
  const { withFilters, currentPath, handlePagePathChange } = usePageContentContext();
  const { dataRegions, dropdownEntity, selectEntity, dropdownSubEntity, setSubEntity,
    entity, subEntity, isToApplyFilters, setIsToApplyFilters, setMapViewType,
    selectedLayer, setSelectedLayer, mapItemsIncidentsData, mapItemsServicesData, isFetchingMapServicesData,
    IVPData, OVPData, classes, setClasses, dropdownClasses, dropdownClassesServices,
    dropdownClassesIncidents, isClassesFetching, items,
    prioritiesSelected, setPrioritiesSelected, refetchMapItemsIncidents, setIsClassesFetching, prioritiesDropdown,
    severityDropdown, severitySelected, setSeveritySelected,
    combinedFilteredPOIs, activeLayerFilters
  } = useGlobalFilterContext();

  const isAllMunicipalitiesSelection = subEntity?.value === ALL_MUNICIPALITIES_VALUE
    || subEntity?.isAllMunicipalities === true;

  const buildingItems = useMemo(() => (
    (mapItemsServicesData || []).filter((item) => item?.type === 'Buildings' || item?.family?.startsWith('Buildings'))
  ), [mapItemsServicesData]);

  useEffect(() => {
    if (!isAllMunicipalitiesSelection || !dropdownSubEntity) {
      return;
    }

    const firstMunicipality = dropdownSubEntity?.find(option => (
      option?.value !== ALL_MUNICIPALITIES_VALUE && !option?.isAllMunicipalities
    ));
    if (firstMunicipality) {
      setSubEntity(firstMunicipality);
    }
  }, [dropdownSubEntity, isAllMunicipalitiesSelection, setSubEntity]);

  const isMunicipalitySelectionPending = !subEntity || isAllMunicipalitiesSelection;

  // WMS/WFS Configurations
  const [wmsConfig, setWmsConfig] = useState(null);
  const [wfsConfig, setWfsConfig] = useState(null);

  const mapDataLayers = [
    { value: "Incidents", label: "Incidents_Layer" },
    { value: "Services", label: "Services_Layer" }
  ];

  function renderPage(currentPath) {
    try {
      if (currentPath) {
        if (currentPath?.includes('/map') && zones?.includes('map')) {
          logger.info('User ' + user?.Username + ' went to map page! Tenant: ' + tenant)
          if (isMunicipalitySelectionPending) {
            return <div />;
          }
          return (
            <Suspense fallback={<div></div>}>
              <Map query={query} tenant={tenant} user={user} appName={REACT_APP_PROJECT_NAME}
                tags={tags} token={token} zones={zones}
                entity={entity} subEntity={subEntity} isToApplyFilters={isToApplyFilters}
                setIsToApplyFilters={setIsToApplyFilters} setMapViewType={setMapViewType} headerHeight='88px'
                mapDataLayers={mapDataLayers} handlePagePathChange={handlePagePathChange}
                selectedLayer={selectedLayer} setSelectedLayer={setSelectedLayer}
                mapItemsIncidentsData={mapItemsIncidentsData}
                mapItemsServicesData={mapItemsServicesData}
                isFetchingMapServicesData={isFetchingMapServicesData}
                IVPData={IVPData}
                OVPData={OVPData}
                classes={classes}
                setClasses={setClasses}
                prioritiesSelected={prioritiesSelected}
                setPrioritiesSelected={setPrioritiesSelected}
                refetchMapItemsIncidents={refetchMapItemsIncidents}
                setIsClassesFetching={setIsClassesFetching}
                dropdownClasses={dropdownClasses}
                prioritiesDropdown={prioritiesDropdown}
                severityDropdown={severityDropdown}
                severitySelected={severitySelected}
                setSeveritySelected={setSeveritySelected} 
                wmsConfig={wmsConfig}
                setWmsConfig={setWmsConfig}
                wfsConfig={wfsConfig}
                setWfsConfig={setWfsConfig}
                combinedFilteredPOIs={combinedFilteredPOIs}
                activeLayerFilters={activeLayerFilters}
              />
            </Suspense>
          );
        }
        // if (currentPath?.includes('/registry/item') && zones?.includes('registry')) {
        //     console.log('deloitte');
        //     logger.info('User ' + user?.Username + ' went to registry item page! Tenant: ' + tenant)
        //     return <Registry query={query} tenant={tenant} user={user} appName='unified_buildings'
        //         tags={tags} />;
        // }
        if (currentPath?.includes('/registry') && zones?.includes('registry')) {
          logger.info('User ' + user?.Username + ' went to register page! Tenant: ' + tenant)
          return (
            <Suspense fallback={<div></div>}>
              <Registry query={query} tenant={tenant} user={user} appName={REACT_APP_PROJECT_NAME}
                tags={tags} />
            </Suspense>
          );
        }
        if (currentPath?.includes('/events') && zones?.includes('events')) {
          logger.info('User ' + user?.Username + ' went to events page! Tenant: ' + tenant)
          return (
            <Suspense fallback={<div></div>}>
              <Events query={query} tenant={tenant} user={user} appName={REACT_APP_PROJECT_NAME}
                tags={tags} entity={entity} subEntity={subEntity} 
                classes={classes} isToApplyFilters={isToApplyFilters} />
            </Suspense>
          );
        }
        if (currentPath?.includes('/analytics') && zones?.includes('analytics')) {
          logger.info('User ' + user?.Username + ' went to analytics page! Tenant: ' + tenant)
          return (
            <Suspense fallback={<div></div>}>
              <Analytics query={query} tenant={tenant} user={user} appName={REACT_APP_PROJECT_NAME}
                tags={tags} limitCheckboxes={4}
                showMunicipalityColumn={false}
                showRegionColumn={true}
                showBuildingColumn={true} />
            </Suspense>
          );
        }
        if (currentPath?.includes('/configurations') && zones?.includes('configurations')) {
          logger.info('User ' + user?.Username + ' went to configurations page! Tenant: ' + tenant)
          return (
            <Suspense fallback={<div></div>}>
              <Configurations query={query} tenant={tenant} user={user} appName={REACT_APP_PROJECT_NAME}
                tags={tags} permissions={permissions} headerHeight="88px" />
            </Suspense>
          );
        }
        if (currentPath?.includes('/buildings') && zones?.includes('buildings')) {
          logger.info('User ' + user?.Username + ' went to buildings page! Tenant: ' + tenant)
          return (
            <Suspense fallback={<div></div>}>
              <Buildings
                queryConfig={query}
                tenant={tenant}
                user={user}
                appName={REACT_APP_PROJECT_NAME}
                tags={tags}
                token={token}
                dropdownEntity={dropdownEntity}
                entity={entity}
                selectEntity={selectEntity}
                dropdownSubEntity={dropdownSubEntity}
                subEntity={subEntity}
                setSubEntity={setSubEntity}
                classOptions={dropdownClassesServices}
                isClassesFetching={isFetchingMapServicesData}
                sourceItems={buildingItems}
              />
            </Suspense>
          );
        }
        if (currentPath?.includes('/home') && zones?.includes('home')) {
          logger.info('User ' + user?.Username + ' went to homepage! Tenant: ' + tenant);
          return (
            <Suspense fallback={<div></div>}>
              <Homepage
                query={query}
                tenant={tenant}
                user={user}
                appName={REACT_APP_PROJECT_NAME}
                tags={tags}
                token={token}
                zones={zones}
                permissions={permissions}
                entity={entity}
                subEntity={subEntity}
                dataRegions={dataRegions}
                dropdownEntity={dropdownEntity}
                selectEntity={selectEntity}
                dropdownSubEntity={dropdownSubEntity}
                setSubEntity={setSubEntity}
                classes={classes}
                setClasses={setClasses}
                dropdownClasses={dropdownClasses}
                dropdownClassesServices={dropdownClassesServices}
                dropdownClassesIncidents={dropdownClassesIncidents}
                isClassesFetching={isClassesFetching}
                setIsClassesFetching={setIsClassesFetching}
                selectedLayer={selectedLayer}
                setSelectedLayer={setSelectedLayer}
                items={items}
                serviceItems={mapItemsServicesData}
                rightContentId="RightContent"
                headerHeight="88px"
                showSubscribeButton={false}
                showEditDashboardButton={true}
                showVerticalsFilter={false}
              />
            </Suspense>
          );
        }

        return null;
      }
    } catch (error) {
      console.error('(Home page) Error in rendering Page currenntPath:', error);
      //reportError(error); // Send error report to backend
      logger.error("(Home page) User " + user?.Username + " Tenant: " + tenant + ', Error in rendering Page currenntPath:', error)
    }
  }

  return (
    <Container>
      <Header />
      <MainContent>
        {withFilters ?
          <FiltersContainer>
            <Filters />
          </FiltersContainer>
          : null
        }

        <RightContent id="RightContent">
          {renderPage(currentPath)}
          {!currentPath?.includes('/map') && !currentPath?.includes('/registry/item') && !currentPath?.includes('/configurations') ? <Footer /> : null}
        </RightContent>
      </MainContent>
    </Container>
  );
}